import type { Option } from '@branchjs/neo-components';
import type { Action } from 'redux';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const UpdateTags = new ReduxAsyncAction<'UPDATE_TAGS', Option | Option[], { tags: Option | Option[] }>('UPDATE_TAGS');

UpdateTags.registerRequest(async (tags: Option | Option[]) => {
  return { tags };
});

export const UPDATE_TAGS = UpdateTags.actionNamespaceConstants;
export const updateTags = UpdateTags.request;

export type UpdateTagsResponseAction = Action<typeof UPDATE_TAGS.response> & {
  data: { tags: Option | Option[] };
};
